import { render } from "./LiverSpecificSectionDetails.vue?vue&type=template&id=10307195&scoped=true"
import script from "./LiverSpecificSectionDetails.vue?vue&type=script&lang=js"
export * from "./LiverSpecificSectionDetails.vue?vue&type=script&lang=js"

import "./LiverSpecificSectionDetails.vue?vue&type=style&index=0&id=10307195&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10307195"],['__file',"src/components/LiverSpecificSectionDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10307195"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10307195', __exports__)) {
    api.reload('10307195', __exports__)
  }
  
  module.hot.accept("./LiverSpecificSectionDetails.vue?vue&type=template&id=10307195&scoped=true", () => {
    api.rerender('10307195', render)
  })

}


export default __exports__